import api from "../api"; // Importa o axios configurado

/**
 * Lista todos os usuários cadastrados no sistema
 * @returns {Promise<Object>} - Lista de usuários
 */
export async function listarUsuarios() {
  try {
    const response = await api.get("/chat/listar_usuarios.php", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao listar usuários:", error);

    if (error.response && error.response.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao conectar com o servidor.");
  }
}
